import { PlusCircleIcon, Square2StackIcon } from "@heroicons/react/24/solid";
import _ from "lodash";
import React, { useState } from "react";
import constants from "../../utils/constants";
import PrimaryButton from "../Buttons/PrimaryButton";
import {
  CheckboxInput,
  NumberInput,
  SelectInput,
  TextInput,
  ToggleInput,
} from "../Inputs";
import PrimaryTable from "../Tables/PrimaryTable";
import ModalWrapper from "./ModalWrapper";

function StdEntityModal({ isOpen, onClose, onAddStandardEntity }) {
  const [tableName, setTableName] = useState("");
  const [softUser, setSoftUser] = useState(false);
  const [columnName, setColumnName] = useState("");
  const [variableType, setVariableType] = useState("");
  const [isNullable, setIsNullable] = useState(false);
  const [maxLength, setMaxLength] = useState(0);
  const [isForeignKey, setIsForeignKey] = useState("");
  const [foreignKeyEntityName, setForeighKeyEntityName] = useState("");
  const [foreignKeyDisplayProperty, setForeignKeyDisplayProperty] =
    useState("");
  const [foreignKeyName, setForeignKeyName] = useState("");
  const [inSearchCriteria, setInSearchCritera] = useState(false);
  const [detailView, setDetailView] = useState(false);
  const [tabularView, setTabularView] = useState(false);
  const [tableProperties, setTableProperties] = useState([]);
  const [columnNamesList, setColumnNamesList] = useState([]);
  const [apiSpike, setApiSpike] = useState(true);
  const [domainSelect, setDomainSelect] = useState("");
  const [domainNames, setDomainNames] = useState([
    { label: "Admin", value: 0 },
    { label: "User", value: 1 },
  ]);
  const [addDomainName, setAddDomainName] = useState(false);
  const [addDomain, setAddDomain] = useState("");
  const [tableNamesList, setTableNamesList] = useState([]);

  const noFKAddColumn = () => {
    setTableProperties([
      ...tableProperties,
      {
        name: columnName,
        type: variableType.value,
        maxLength: parseInt(maxLength),
        isNullable: isNullable,
        detailView: detailView,
        tabularView: tabularView,
        IncludeInSearchCriteria: inSearchCriteria,
      },
    ]);

    setColumnNamesList([...columnNamesList, columnName]);
    setColumnName("");
    setVariableType("");
    setMaxLength(0);
    setIsNullable(false);
    setDetailView(false);
    setTabularView(false);
    setInSearchCritera(false);
  };

  const fkAddColumn = () => {
    setTableProperties([
      ...tableProperties,
      {
        name: columnName,
        type: variableType.value,
        maxLength: parseInt(maxLength),
        isNullable: isNullable,
        detailView: detailView,
        tabularView: tabularView,
        IncludeInSearchCriteria: inSearchCriteria,
        foreignkey: {
          entity: foreignKeyEntityName,
          property: "Id",
          name: foreignKeyName,
          displayProperty: foreignKeyDisplayProperty,
        },
      },
    ]);
    setColumnNamesList([...columnNamesList, columnName]);

    setColumnName("");
    setVariableType("");
    setMaxLength(0);
    setIsNullable(false);
    setDetailView(false);
    setTabularView(false);
    setInSearchCritera(false);
    setIsForeignKey(false);
  };
  const Add = () => {
    onAddStandardEntity(
      tableName,
      apiSpike,
      domainSelect.value,
      softUser,
      tableProperties
    );
    setTableName("");
    setTableNamesList([...tableNamesList, tableName]);
    setColumnNamesList([]);
    setTableProperties([]);
    setApiSpike(false);
    setSoftUser(false);
  };

  return (
    <div className="w-screen h-auto ">
      <ModalWrapper open={isOpen} setOpen={onClose}>
        <div className="w-[90vw] h-auto px-8">
          <div className="pb-4 text-center flex items-center flex-col">
            <Square2StackIcon className="w-5 text-gray-500" />
            Add Standard Entities
          </div>

          <div className="pb-8 mx-6 text-center text-sm text-gray-500">
            User, Role, UserRole, and UserAuthenticationAttempt are created by
            default -- do not include these
          </div>
          <div className="w-1/2"></div>
          <div className="grid grid-cols-4 gap-1 relative flex items-end mb-8">
            <div>
              <TextInput
                label="Table Name"
                placeholder="Enter Table Name (singular, PascalCase)"
                value={tableName}
                onChange={(e) => setTableName(e.target.value)}
              />
            </div>

            <CheckboxInput
              label="IsSoftDeletable"
              checked={softUser}
              setChecked={() => setSoftUser(!softUser)}
            />
            <CheckboxInput
              label="IsUserManaged"
              checked={softUser}
              setChecked={() => setSoftUser(!softUser)}
            />
            <CheckboxInput
              label="IncludeInApiSpike"
              checked={apiSpike}
              setChecked={() => setApiSpike(!apiSpike)}
            />
          </div>
          <div>
            {!apiSpike ? (
              <>
                {" "}
                <h6 className="font-semibold my-3 text-center">
                  Selecting IncludeInApiSpike creates a frontend, controller,
                  service, and repository for the entity. Otherwise only
                  migration, model, mapping, dto, and automapper are produced.{" "}
                </h6>
              </>
            ) : null}
          </div>
          <div>
            {apiSpike ? (
              <>
                <h7 className="font-semibold my-3 ">
                  Select a domain(optional).
                </h7>
                <h7 className="font-semibold my-3">
                  Domain Name is the name of the controller, service and
                  repository.
                </h7>
                <div className="grid grid-cols-4 gap-1 relative flex items-center mb-8">
                  <SelectInput
                    options={domainNames}
                    onClear={() => setDomainSelect({})}
                    value={domainSelect}
                    onChange={(label) => setDomainSelect(label)}
                    placeholder="Choose a domain"
                    isSearchable
                  />
                  <PlusCircleIcon
                    className="w-8 text-primaryColor hover:text-primaryColor/50 cursor-pointer"
                    onClick={() => setAddDomainName(true)}
                    title="Add a domain name to the options list"
                  />

                  {addDomainName ? (
                    <>
                      <TextInput
                        placeholder="Add a Domain Name"
                        value={addDomain}
                        onChange={(e) => setAddDomain(e.target.value)}
                      />
                      <PrimaryButton
                        className="w-full min-h-[2rem]"
                        text="Add Domain Name"
                        onClick={() => {
                          setDomainNames([
                            ...domainNames,
                            {
                              label: addDomain,
                              value:
                                parseInt(
                                  domainNames[domainNames.length - 1].value
                                ) + 1,
                            },
                          ]);
                          setAddDomainName(false);
                        }}
                        disabled={
                          addDomain.trim() === "" ||
                          _.some(domainNames, { label: addDomain })
                        }
                      />{" "}
                    </>
                  ) : null}
                </div>
              </>
            ) : null}
          </div>

          <div className="mt-3">
            <div className="my-4 p-4 bg-gray-200 rounded-lg">
              <PrimaryTable
                paginatorHidden="true"
                header={
                  <PrimaryTable.Header className="text-center">
                    <PrimaryTable.HeaderColumn
                      className="text-center"
                      display="Column Name"
                    />
                    <PrimaryTable.HeaderColumn display="Variable Type" />
                    {["String", "Ansistring", "Binary", "Decimal"].includes(
                      variableType.label
                    ) && (
                      <>
                        {" "}
                        <PrimaryTable.HeaderColumn display="Max length" />{" "}
                      </>
                    )}
                    <PrimaryTable.HeaderColumn display="Nullable" />
                    <PrimaryTable.HeaderColumn display="Foreign Key" />
                    {isForeignKey ? (
                      <>
                        <PrimaryTable.HeaderColumn display="Foreign Key Entity Name" />
                        <PrimaryTable.HeaderColumn display="Foreign Key Display Property" />
                        <PrimaryTable.HeaderColumn display="Foreign Key Name" />
                      </>
                    ) : null}
                    <PrimaryTable.HeaderColumn display="Include In Search Criteria" />
                    <PrimaryTable.HeaderColumn display="Detail View" />
                    <PrimaryTable.HeaderColumn display="Tabular View" />
                    <PrimaryTable.HeaderColumn />
                  </PrimaryTable.Header>
                }
              >
                <PrimaryTable.Row>
                  <PrimaryTable.Cell>
                    <TextInput
                      value={columnName}
                      label="Required"
                      onChange={(e) => setColumnName(e.target.value)}
                    />
                  </PrimaryTable.Cell>

                  <PrimaryTable.Cell>
                    {" "}
                    <SelectInput
                      label="Required"
                      options={constants.VARIABLE_TYPES}
                      onClear={() => setVariableType("")}
                      value={variableType}
                      onChange={setVariableType}
                      placeholder={variableType}
                    />
                  </PrimaryTable.Cell>
                  {["String", "Ansistring", "Binary", "Decimal"].includes(
                    variableType.label
                  ) && (
                    <>
                      {" "}
                      <PrimaryTable.Cell>
                        <NumberInput
                          label="Required"
                          value={maxLength}
                          onChange={(e) => setMaxLength(e.target.value)}
                        />
                      </PrimaryTable.Cell>{" "}
                    </>
                  )}

                  <PrimaryTable.Cell>
                    <ToggleInput
                      enabled={isNullable}
                      setEnabled={setIsNullable}
                    />
                  </PrimaryTable.Cell>

                  <PrimaryTable.Cell>
                    <ToggleInput
                      enabled={isForeignKey}
                      setEnabled={setIsForeignKey}
                    />
                  </PrimaryTable.Cell>
                  {isForeignKey ? (
                    <>
                      <PrimaryTable.Cell>
                        <TextInput
                          label="Required"
                          value={foreignKeyEntityName}
                          onChange={(e) =>
                            setForeighKeyEntityName(e.target.value)
                          }
                        />
                      </PrimaryTable.Cell>

                      <PrimaryTable.Cell>
                        <TextInput
                          label="Optional"
                          value={foreignKeyDisplayProperty}
                          onChange={(e) =>
                            setForeignKeyDisplayProperty(e.target.value)
                          }
                        />
                      </PrimaryTable.Cell>
                      <PrimaryTable.Cell>
                        <TextInput
                          label="Required. Example: FK_FavoriteCustomerId_Restaurant"
                          value={foreignKeyName}
                          onChange={(e) => setForeignKeyName(e.target.value)}
                        />
                      </PrimaryTable.Cell>
                    </>
                  ) : null}
                  <PrimaryTable.Cell>
                    <ToggleInput
                      enabled={inSearchCriteria}
                      setEnabled={setInSearchCritera}
                    />
                  </PrimaryTable.Cell>
                  <PrimaryTable.Cell>
                    <ToggleInput
                      enabled={detailView}
                      setEnabled={setDetailView}
                    />
                  </PrimaryTable.Cell>
                  <PrimaryTable.Cell>
                    <ToggleInput
                      enabled={tabularView}
                      setEnabled={setTabularView}
                    />
                  </PrimaryTable.Cell>
                  <PrimaryTable.Cell>
                    {isForeignKey ? (
                      <PrimaryButton
                        text="Add column"
                        onClick={fkAddColumn}
                        disabled={
                          columnName.trim() === "" || variableType === ""
                        }
                      />
                    ) : (
                      <PrimaryButton
                        text="Add column"
                        onClick={noFKAddColumn}
                        disabled={
                          columnName.trim() === "" || variableType === ""
                        }
                      />
                    )}
                  </PrimaryTable.Cell>
                </PrimaryTable.Row>
              </PrimaryTable>
            </div>
            <div className="my-4 p-4 bg-gray-200 rounded-lg">
              <h3 className="font-bold text-xl mb-3 text-center">
                {tableName}
              </h3>

              <PrimaryTable
                paginatorHidden="true"
                header={
                  <PrimaryTable.Header className="text-center">
                    {_.map(columnNamesList, (x) => (
                      <PrimaryTable.HeaderColumn
                        className="text-center"
                        display={x}
                      />
                    ))}
                  </PrimaryTable.Header>
                }
              ></PrimaryTable>
            </div>
          </div>

          <div className="py-2" />
          <PrimaryButton
            text="Add Entity to Project"
            onClick={Add}
            disabled={_.includes(tableNamesList, tableName)}
          />
        </div>
      </ModalWrapper>
    </div>
  );
}

export default StdEntityModal;
